<template>
  <div class="app-container">
    <CrudTable entity="Special" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'description',
        { field: 'descriptionOnTicket', label: 'special.descriptionOnTicket' },
        {
          field: 'specialType',
          label: 'special.specialType',
          formatter: this.formatSpecialType,
          sortable: false,
          filter: {
            type: 'none'
          }
        },
        {
          field: 'activeYN',
          label: 'common.active',
          formatter: this.formatActive,
          filter: { type: 'none' },
          sortable: false
        }
      ]
    };
  },
  methods: {
    generateSummary({ description }) {
      const summary = `${description}`;
      return summary;
    },
    formatActive(row, column, cellValue) {
      return cellValue ? this.$t('common.yes') : this.$t('common.no');
    },
    formatSpecialType(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('specialType').find(item => item.code === cellValue);
      return option && option.description;
    }
  }
};
</script>
